import styled from 'styled-components';

// Shared by the header and each receipt row so the columns stay aligned
export const COLUMN_FLEX = {
  date: 1,
  findMetric: 1,
  replaceMetric: 1,
  itemsAffected: 0.6,
};

export const ArrowCol = styled.div`
  flex: 0 0 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 8px;
`;

export const MenuCol = styled.div`
  flex: 0 0 40px;
  display: flex;
  justify-content: flex-end;
`;
